module.exports = __webpack_public_path__ + "img/qr_card_example.86ef04db.png";